import { ref, readonly } from 'vue';

const _isVisibleModalCardManage = ref(false);
const _isModeCheckout = ref(false);
const _isHidden = ref(false);

export const useModalCardManage = () => {
  const isVisibleModalCardManage = readonly(_isVisibleModalCardManage);
  const isModeCheckout = readonly(_isModeCheckout);
  const isHiddenModalCardManage = readonly(_isHidden);

  const openModalCardManage = ({ isModeCheckout = false }) => {
    setIsModeCheckout(isModeCheckout);
    _isVisibleModalCardManage.value = true;
  };
  const closeModalCardManage = () => (_isVisibleModalCardManage.value = false);

  const setIsModeCheckout = (newVal) => {
    _isModeCheckout.value = newVal;
  };

  const setIsHiddenModalCardManage = (newVal) => {
    _isHidden.value = newVal;
  };

  return {
    isVisibleModalCardManage,
    isModeCheckout,
    isHiddenModalCardManage,
    openModalCardManage,
    closeModalCardManage,
    setIsHiddenModalCardManage,
  };
};
